export default __webpack_public_path__ + "static/media/Backoffice  Active - Hover.d5e99b0b.svg";